import { styled } from 'stitches.config'

export const Step1Root = styled('div', {
  backgroundColor: '$secondary-100',
  paddingBottom: '$10',
  px: '$3',
  $$headerHeight: '80px',
  $$stepperHeight: '130px',
  $$mobileStepperHeight: '74px',
  $$footerHeight: '373px',
  '& label': {
    fontWeight: '$medium',
    fontSize: '$body',
    lineHeight: '$body',
    textAlign: 'center',
    display: 'block',
    width: '100%',

    '@bp2': {
      fontSize: '$headline',
      lineHeight: '$headline',
    },
  },

  '@bp1': {
    minHeight: 'calc(100vh - $$headerHeight - $$mobileStepperHeight - $$footerHeight)',
  },

  '@bp2': {
    minHeight: 'calc(100vh - $$headerHeight - $$stepperHeight - $$footerHeight)',
    px: '120px',
  },
})
